import styled, { keyframes } from 'styled-components';
import { RayLayer1 } from './RayLayer1';
import { RayLayer2 } from './RayLayer2';

const rotate = keyframes`
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
`;

const RayContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 0;
`;

const Layer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vh;
  transform: translate(-50%, -50%);
  animation: ${rotate} ${props => props.$duration}s linear infinite;
  opacity: 0.35;

  svg {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const AnimatedRays = () => {
  return (
    <RayContainer>
      <Layer $duration={40}>
        <RayLayer1 />
      </Layer>
      <Layer $duration={60}>
        <RayLayer2 />
      </Layer>
    </RayContainer>
  );
};
